import dxButton from "devextreme/ui/button";
import dxLoadPanel from "devextreme/ui/load_panel";
import dxNotify from "devextreme/ui/notify";
import dxPopup from "devextreme/ui/popup";
import dxSelectBox from "devextreme/ui/select_box";
import dxTagBox from "devextreme/ui/tag_box";
import { NodejsAdonis } from "../componentes-padrao/AxiosConfig";
import ControleSessao from "../componentes-padrao/ControleSessao";
import MenuNavegacao from "../componentes-padrao/MenuNavegacao";
import { analyticsApi, api } from "../modules/Axios/api";
import {
    getBranchesAllowed,
    getCompaniesAllowed,
    setEmpresa,
} from "../services/auth/api";
import { setUserTheme } from "../services/user-theme";
import { PopUpAtualizacao } from "../telas/jornada/PopUpAtualizacao";

class selecionaEmpresa {
    constructor() {
        // Gera HTML novamente caso tenha sido trocado de empresa
        if ($("#drawer").length == 0) {
            $(".raster-app").append("<div id='drawer' />");
            $(".raster-app").append("<div id='loading' />");
            $(".raster-app").append("<div id='popup' />");

            $("#drawer").append("<div id='tabpanel' />");
            $("#tabpanel").append("<div id='tabpanel-container' />");
        }

        this.renderCampoEmpresa = this.campoEmpresa();
        this.renderCampoFilial = this.campoFilial();
        this.renderButtonSubmit = this.buttonSubmit();

        this._evtListner = (evt) => this.evtListnerKeypress(evt);

        this.render();
    }

    render() {
        const content = $("#popup");
        this.popupSelecionaEmpresas = new dxPopup(content, {
            dragEnabled: false,
            visible: true,
            title: "Empresa/filial",
            fullScreen: false,
            resizeEnabled: false,
            showCloseButton: false,
            deferRendering: false,
            width: () => {
                if (window.innerWidth > 450) {
                    return "450px";
                }
                return `${window.innerWidth - 108}px`;
            },
            height: "auto",
            shadingColor: "rgba(17, 95, 157, 0)",
            position: { my: "center", at: "center", of: window },
            contentTemplate: (conteudo) => {
                $(`<div class="selecionar-empresa-logo"/>`).appendTo(conteudo);

                this.renderCampoEmpresa.content.appendTo(
                    $("<div style='margin-top: 15px;'>Empresa:</div>").appendTo(
                        conteudo,
                    ),
                );
                this.renderCampoFilial.content.appendTo(
                    $("<div style='margin-top: 15px;'>Filial:</div>").appendTo(
                        conteudo,
                    ),
                );
                this.renderButtonSubmit.content.appendTo(
                    $(
                        "<div style='float: right; margin-bottom: 5px; margin-top: 10px; margin-right: 0;' id='avanca-empresa-filial' />",
                    ).appendTo(conteudo),
                );

                document
                    .querySelector("body")
                    .addEventListener("keypress", this._evtListner);
            },
            onHiding: (e) => (e.cancel = true),
        });
        this.popupSelecionaEmpresas.show();

        const fundoLogin = $(`<div class="bg-imagem"></div>`);
        content.append(fundoLogin);

        return content;
    }

    campoEmpresa() {
        const content = $("<div />");

        const instance = new dxSelectBox(content, {
            dataSource: [],
            displayExpr: "reason",
            valueExpr: "id",
            searchEnabled: true,
            disabled: true,
            placeholder: "Carregando... Aguarde.",
            onValueChanged: ({ value, component }) => {
                this.renderCampoFilial.instance.option("value", []); // Limpa selecao de filial ao trocar de empresa
                this.renderCampoFilial.instance.option(
                    "placeholder",
                    "Carregando... Aguarde.",
                );
                this.renderCampoFilial.instance.option("disabled", true);
                component.option("validationStatus", "valid");

                sessionStorage.setItem("REPORT_KEY", Base64.encode(value));

                getBranchesAllowed(value).then((branches) => {
                    this.renderCampoFilial.instance.option(
                        "dataSource",
                        branches,
                    );
                    this.renderCampoFilial.instance.option("disabled", false);
                    this.renderCampoFilial.instance.option(
                        "placeholder",
                        "Selecione uma filial",
                    );

                    if (branches.length === 1) {
                        this.renderCampoFilial.instance.option("value", [
                            branches[0].id,
                        ]);
                    } else {
                        this.renderCampoFilial.instance.option("value", []);
                        this.renderCampoFilial.instance.open();
                    }
                });
            },
        });

        getCompaniesAllowed().then((companies) => {
            instance.option("dataSource", companies);
            instance.option("disabled", false);
            instance.option("placeholder", "Selecione uma empresa");

            if (companies.length === 1) {
                instance.option("value", companies[0].id);
            } else {
                instance.open();
            }
        });

        return {
            content,
            instance,
        };
    }

    campoFilial() {
        const content = $("<div />");

        const instance = new dxTagBox(content, {
            displayExpr: "reason",
            valueExpr: "id",
            showSelectionControls: true,
            multiline: false,
            dataSource: [],
            disabled: true,
            placeholder: "Selecione uma filial",
            onValueChanged: ({ value, component }) => {
                component.option("validationStatus", "valid");
                if (value.length == 1) {
                    this.campoFilial().instance.option("close");
                }
            },
        });

        return {
            content,
            instance,
        };
    }

    buttonSubmit() {
        const loading = new dxLoadPanel($(".loadpanel"), {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { my: "center", at: "center" },
            visible: false,
            showIndicator: true,
            showPane: true,
            shading: true,
            closeOnOutsideClick: false,
            message: "Carregando, aguarde.",
        });

        const content = $('<div id="login-button" />');
        const instance = new dxButton(content, {
            icon: "chevronright",
            type: "normal",
            text: "Prosseguir",
            stylingMode: "outlined",
            onClick: async () => {
                try {
                    const empresaValue =
                        this.renderCampoEmpresa.instance.option("value");
                    const filialValue =
                        this.renderCampoFilial.instance.option("value");

                    if (!empresaValue || !filialValue.length) {
                        if (!empresaValue)
                            this.renderCampoEmpresa.instance.option(
                                "validationStatus",
                                "invalid",
                            );
                        if (!filialValue.length)
                            this.renderCampoFilial.instance.option(
                                "validationStatus",
                                "invalid",
                            );
                        return;
                    }

                    loading.show();

                    await this.setEmpresaLogada(empresaValue, filialValue);

                    const { menuFiliais } =
                        this.getFiliaisSelecionadas(filialValue);

                    ControleSessao.setFiliais(
                        menuFiliais.map((filial) => {
                            return {
                                CAB_CODIGO: filial.CAB_CODIGO,
                                CAB_RAZAO: filial.CAB_RAZAO,
                            };
                        }),
                    );

                    loading.hide();

                    this.popupSelecionaEmpresas.dispose();

                    document
                        .querySelector("body")
                        .removeEventListener("keypress", this._evtListner);

                    if ($(".dx-drawer-panel-content").length) {
                        $(".dx-drawer-panel-content").attr("style", "");
                        $(".dx-drawer-panel-content").html("");
                        $("#toolbar").html("");
                    }

                    // Remove elementos DOM relacionados a popup após fecha-lo
                    $("#popup").remove();
                    $(".raster-app").append("<div id='popup' />");

                    this.logUserAccess();

                    let dezSegundos = 10000;
                    analyticsApi
                        .get("/notice", { timeout: dezSegundos })
                        .then((response) => {
                            const resultadoBusca = response.data;
                            if (resultadoBusca) {
                                const linkLabel =
                                    resultadoBusca.link?.label ||
                                    resultadoBusca.link?.url;
                                const popupAtualizacao = new PopUpAtualizacao(
                                    resultadoBusca.title || undefined,
                                    resultadoBusca.description
                                        ? resultadoBusca?.description?.slice(
                                              0,
                                              2000,
                                          )
                                        : undefined,
                                    resultadoBusca.image_url
                                        ? resultadoBusca?.image_url
                                        : undefined,
                                    resultadoBusca.link.url
                                        ? resultadoBusca?.link?.url
                                        : undefined,
                                    linkLabel
                                        ? linkLabel?.slice(0, 200)
                                        : undefined,
                                    resultadoBusca?.variant || undefined,
                                );
                                popupAtualizacao
                                    .getRender()
                                    .appendTo(document.body);
                                popupAtualizacao.getDxPopUp().show();
                            } else {
                                console.error(
                                    "Nenhum dado recebido de RELEASE API.",
                                );
                            }
                        })
                        .catch((error) => {
                            console.error("Erro ao buscar dados:", error);
                        });

                    if (!ControleSessao.getUsuarioInterno()) {
                        api.get("/timesheet-closing/dates", {
                            params: {
                                company_id: empresaValue,
                            },
                            timeout: dezSegundos,
                        }).then((response) => {
                            const closing_date = new Date();
                            closing_date.setDate(
                                response.data.last_day_timesheet,
                            );
                            const current_date = new Date();

                            const differenceInDaysFromCurrentDateToClosingDate =
                                (current_date - closing_date) /
                                (1000 * 60 * 60 * 24);

                            if (
                                1 <=
                                    differenceInDaysFromCurrentDateToClosingDate &&
                                differenceInDaysFromCurrentDateToClosingDate <=
                                    5
                            ) {
                                const popupAtualizacao = new PopUpAtualizacao(
                                    "<strong> Atenção! </strong>",
                                    "Identificamos que o período do seu cartão ponto foi finalizado. Recomendamos realizar o fechamento após o pagamento dos motoristas, a fim de garantir a integridade dos dados no futuro." +
                                        '<br><br>O fechamento pode ser feito na tela <strong>"Controle de Jornada"</strong>, por meio do botão <strong>"Controle de Fechamento de Cartão"</strong>' +
                                        "<br><br>Em caso de dúvidas sobre o procedimento, entre em contato com nossa equipe de suporte." +
                                        "<br><br>Lembre-se: o fechamento dos cartões-ponto é a forma mais segura de evitar alterações em períodos retroativos, assegurando que reprocessos, alterações em associações e eventos não afetem dados de cartões para os quais os pagamentos já foram realizados." +
                                        "<br><br>Ao não realizar o fechamento, você declara estar ciente dos riscos de manter os períodos em aberto.",
                                    undefined,
                                    undefined,
                                    undefined,
                                    undefined,
                                );
                                popupAtualizacao
                                    .getRender()
                                    .appendTo(document.body);
                                popupAtualizacao.getDxPopUp().show();
                            }
                        });
                    }

                    await setUserTheme();

                    new MenuNavegacao(
                        this.renderCampoEmpresa.instance.option("text"),
                        menuFiliais,
                    ).render();
                } catch (error) {
                    console.log(error);
                    dxNotify("Tente novamente.", "error", 2500);
                } finally {
                    loading.dispose();
                }
            },
        });

        return {
            content,
            instance,
        };
    }

    evtListnerKeypress(evt) {
        if (evt.key == "Enter") {
            this.renderButtonSubmit.content.click();
        }
    }

    getFiliaisSelecionadas(filiais) {
        const dataSourceFiliais =
            this.renderCampoFilial.instance.option("dataSource");

        const filialSelecionadas = filiais.map((filialID) => {
            const filial = dataSourceFiliais.find(
                (item) => item.id === filialID,
            );
            return {
                CAB_CODIGO: filial.id,
                CAB_RAZAO: filial.reason,
            };
        });

        const itemMenuFiliais = filialSelecionadas.map((filial) => ({
            ...filial,
            disabled: true,
        }));

        return { menuFiliais: itemMenuFiliais };
    }

    async setEmpresaLogada(empresaID, filialIDs) {
        await setEmpresa({
            empresaID: empresaID,
            filialIDs: filialIDs,
        });
    }
    logUserAccess() {
        NodejsAdonis.post("jor/acessos");
    }
}

export default selecionaEmpresa;
